if (!Librarian.MessageListeners) {
    Librarian.MessageListeners = {
        server: null,
        listeners: {},

        init: function () {
            this.server = new MessengerServer();

            this.loadListeners();
        },

        loadListeners: function () {
            var server = this.server;

            Object.each(this.listeners, function (listener, key) {
                server.addListener(function (message) {
                    if (message.action === key) {
                        var data = message.data || {};
                        listener(data);
                    }
                });
            });
        },

        sendMessageToChild: function(childWindow, payload) {
            this.server.sendMessageToChild(childWindow, "DISPATCH", payload);
        }
    };

    Librarian.MessageListeners.listeners["open-share-dialog"] = function (data) {
        new Librarian.EventSendWindow(data, data ? data.contents : null);
    };

    Librarian.MessageListeners.listeners["open-campaign-dialog"] = function (data) {
        new Librarian.Utils.openCampaignWindow({ "campaignInfo": data });
    };

    Librarian.MessageListeners.listeners["navigate-to-page"] = function (data) {
        if (data.pageName != null && data.pageName.length > 0) {
            Librarian.Modules.Nav.navigateToPage(data.pageName);
        }
    };

    Librarian.MessageListeners.listeners["open-tab"] = function (data) {
        if (data.id != null && data.id.length > 0) {
            //initializer.onTabClicked.call(data, null, null);
            var tab = $(data.id);
            tab.forceLoadHome = data.forceLoadHome || false;
            tab.click();
        }
    };

    Librarian.MessageListeners.listeners["open-file"] = function (data) {
        Librarian.Modules.OpenFile.openFile(data.filename, "SearchFiles", "SearchSlides", data.options);
    };

    Librarian.MessageListeners.listeners["open-content-manager"] = function () {
        var win = window.open(Librarian.path.getAppPath("admin") + "/manager.htm?libName=" + Librarian.path.getUrlLibraryName(), '_blank');
        if (win) {
            win.focus();
        } else {
            alert('Please allow popups for this website');
        }
    };

    Librarian.MessageListeners.listeners["open-workflow"] = function () {
        Librarian.Utils.openWorkflowToDo();
    };

    Librarian.MessageListeners.listeners["open-my-files"] = function (data) {
        if (data)
            var type = data.type;
        if (type) {
            Librarian.MyFiles.filter = {};
            Librarian.MyFiles.filter[type] = true;
        }
        Library.myFilesClicked();
        Librarian.Init.toggleSideColumn(sideColumn, true, false);
    };

    Librarian.MessageListeners.listeners["open-my-uploads"] = function () {
        Library.myUploadClick(true);
        Librarian.Init.toggleSideColumn(sideColumn, true, false);
    };

    Librarian.MessageListeners.listeners["open-my-creations"] = function () {
        Library.mypresClick(5)
        Librarian.Init.toggleSideColumn(sideColumn, true, false);
    };

    Librarian.MessageListeners.listeners["open-my-bookmarks"] = function () {
        Librarian.Bookmarks.viewBookmarkedContents();
        Librarian.Init.toggleSideColumn(sideColumn, true, false);
    };

    Librarian.MessageListeners.listeners["open-my-profile"] = function () {
        new Librarian.UserProfileWindow().show()
    };

    Librarian.MessageListeners.listeners["open-my-contacts"] = function () {
        new Librarian.MyContactsWindow().show();
    };

    Librarian.MessageListeners.listeners["open-my-favorites"] = function () {
        window.location.hash = ("catid=0&prestype=1&type=6");
        Librarian.Utils.openLibraryTreePanel();
    };

    Librarian.MessageListeners.listeners["open-forum"] = function () {
        window.location.hash = ("page=forum");
    };

    Librarian.MessageListeners.listeners["open-forum-topic"] = function (data) {
        window.location.hash = ("page=forum&topicid=" + data);
    };

    Librarian.MessageListeners.listeners["navigate-to-category"] = function (data) {
        if (data.showTree === undefined)
            data.showTree = true;
        Librarian.Modules.OpenCat.openCategory(data.treeView || 0, data.path, data.showTree);
    };

    Librarian.MessageListeners.listeners["open-newest-files"] = function (data) {
        Librarian.ContentLists.showNewestFiles(data.count,data.showListView);
    };

    Librarian.MessageListeners.listeners["open-url"] = function (data) {
        if (data.url != null && data.url.length > 0) {
            data.target == data.target || "_blank";
            window.open(data.url, data.target);
        }
    };

    Librarian.MessageListeners.listeners["quick-search"] = function (data) {
        Library.quickSearch(data.searchTerm);
        sideColumn.columnToggle();
    };

    Librarian.MessageListeners.listeners["browse"] = function () {
        // if defined, open top folder of file tree
        if (Librarian.treeViews && Librarian.treeViews.treeView && Librarian.treeViews.treeView.root) {
            Librarian.treeViews.treeView.root.toggle(true);
        }

        Librarian.Utils.openLibraryTreePanel();
    };

    Librarian.MessageListeners.listeners["open-topic"] = function (data) {
        window.location.hash = ("page=collaboration&topicid=" + data.topicId);
    };

    Librarian.MessageListeners.listeners["open-popup"] = function (data) {
        new Librarian.Popup({ htmlFile: data.fileName, height: data.popupHeight, useIframe: false });
    };

    Librarian.MessageListeners.listeners["open-html-window"] = function (data) {
        new Librarian.HTMLWindow({
            title: data.title,
            html: data.html,
            placeholders: data.placeholders
        });
    };

    Librarian.MessageListeners.listeners["new-content"] = function (data) {
        Librarian.Utils.getNewestFiles(7,
            function (response) {
                response.data.forEach(function (file) {
                    file.cardType = 5;
                    file.ChannelId = 8;
                    file.ChannelName = "New Content";
                });
                return response;
            });
    };

    Librarian.MessageListeners.listeners["preview-file"] = function(payload) {
        var data = payload.data;
        var options = payload.options;

        Librarian.PreviewWindow.openPreviewWindow(data, null, null, options);
    };

    Librarian.MessageListeners.listeners["add-to-cart"] = function (data) {
        Librarian.userCart.addToCart(data);
    };

    Librarian.MessageListeners.listeners["remove-from-cart"] = function (data) {
        Librarian.userCart.removeFromCart(data);
    };

    Librarian.MessageListeners.listeners["upload-file"] = function (data) {
        Librarian.Utils.openUploader();
    };

    Librarian.MessageListeners.listeners["download-data"] = function (data) {
        Library.downloadData(data);
    };

    Librarian.MessageListeners.listeners["drag-enter"] = function (data) {
        $('desktop').fireEvent('dragenter', data);
    };

    Librarian.MessageListeners.listeners["drag-over"] = function (data) {
        $('desktop').fireEvent('dragover', data);
    };

    Librarian.MessageListeners.listeners["drag-leave"] = function (data) {
        $('desktop').fireEvent('dragleave', data);
    };

    Librarian.MessageListeners.listeners["drop"] = function (data) {
        $('desktop').fireEvent('drop', data);
    };

    Librarian.MessageListeners.listeners["set-homepage"] = function (fileName) {
        Library.setHomepage("page", fileName);
    };

    Librarian.MessageListeners.listeners["custom"] = function () {
        var custom = new Library.customListener();
    };

    Librarian.MessageListeners.listeners["submit-ai-search"] = function (data) {
        Library.execAiSearch(data);
    };

    Librarian.MessageListeners.init();
}